// eslint-disable-next-line max-classes-per-file
class InvoiceItem {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  name: string;
  quantity: number;
  price: number;

  constructor(data: any = {}) {
    const createdAt = new Date(data.createdAt);

    this.id = data.id;
    this.createdAt = createdAt;
    this.updatedAt = new Date(data.updatedAt);
    this.name = data.name;
    this.quantity = data.quantity;
    this.price = data.price;
  }
}

export class InvoiceWorker {
  id: number;
  workerId: number;
  name: string;
  paidAt: Date | null;

  constructor(data: any = {}) {
    this.id = data.id;
    this.workerId = data.workerId;
    this.name = data.name;
    this.paidAt = data.paidAt ? new Date(data.paidAt) : null;
  }
}

export class InvoiceTag {
  tagId: number;
  name: string;
  color: string;

  constructor(data: any = {}) {
    this.tagId = data.tagId;
    this.name = data.name;
    this.color = data.color;
  }
}

export class InvoiceProduct extends InvoiceItem {
  productId: number;

  constructor(data: any = {}) {
    super(data);

    this.productId = data.productId;
  }
}

export class InvoiceService extends InvoiceItem {
  serviceId: number;
  description: string;

  constructor(data: any = {}) {
    super(data);

    this.serviceId = data.serviceId;
    this.description = data.description;
  }
}

export class InvoiceEquipment {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  equipmentId: number;
  name: string;
  brand: string;
  model: string;
  serialNumber: string;
  description: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
    this.equipmentId = data.equipmentId;
    this.name = data.name;
    this.brand = data.brand;
    this.model = data.model;
    this.serialNumber = data.serialNumber;
    this.description = data.description;
  }
}

export class InvoiceViewModel {
  id: number;
  number: string;
  signature: string;
  isSigned: boolean;
  isPaid: boolean;
  transactionNatureId: number;
  transactionNatureName: string;
  statusLabel: string;
  statusState: number;
  companyId: number;
  companyIdentifier: string;
  companyType: number;
  companyName: string;
  companyAlias: string;
  customerId: number;
  customerIdentifier: string;
  customerType: number;
  customerName: string;
  customerAlias: string;
  estimateId: number;
  estimateNumber: string;
  statusId: number;
  createdAt: Date;
  updatedAt: Date;
  paymentDate: Date;
  paymentDescription: string;
  finishedAt: Date;
  startedAt: Date;
  subTotal: number;
  discount: number;
  total: number;
  invoiceInfo1: string;
  invoiceInfo2: string;
  isPayingJustTheHalf: boolean;
  payrollBonus: number;

  invoiceProducts: InvoiceProduct[];
  invoiceServices: InvoiceService[];
  invoiceEquipments: InvoiceEquipment[];
  invoiceWorkers: InvoiceWorker[];
  invoiceTags: InvoiceTag[];

  checked: boolean = false;

  constructor(data: any = {}) {
    const createdAt = new Date(data.createdAt);

    this.id = data.id;
    this.number = data.number;
    this.signature = data.signature;
    this.isSigned = data.isSigned;
    this.isPaid = data.isPaid;
    this.transactionNatureId = data.transactionNatureId;
    this.transactionNatureName = data.transactionNatureName;
    this.statusLabel = data.statusLabel;
    this.statusState = data.statusState;
    this.companyId = data.companyId;
    this.companyIdentifier = data.companyIdentifier;
    this.companyType = data.companyType;
    this.companyName = data.companyName;
    this.customerAlias = data.customerAlias;
    this.companyAlias = data.companyAlias;
    this.statusId = data.statusId;
    this.customerId = data.customerId;
    this.customerIdentifier = data.customerIdentifier;
    this.customerType = data.customerType;
    this.customerName = data.customerName;
    this.estimateId = data.estimateId;
    this.estimateNumber = data.estimateNumber;
    this.createdAt = createdAt;
    this.updatedAt = new Date(data.updatedAt);
    this.paymentDate = data.paymentDate && new Date(data.paymentDate);
    this.paymentDescription = data.paymentDescription;
    this.finishedAt = data.finishedAt && new Date(data.finishedAt);
    this.startedAt = data.startedAt && new Date(data.startedAt);
    this.subTotal = data.subTotal || 0;
    this.discount = data.discount || 0;
    this.total = data.total || 0;
    this.invoiceInfo1 = data.invoiceInfo1;
    this.invoiceInfo2 = data.invoiceInfo2;
    this.isPayingJustTheHalf = data.isPayingJustTheHalf;
    this.payrollBonus = data.payrollBonus;

    this.invoiceProducts =
      (data.invoiceProducts &&
        data.invoiceProducts.map(
          (invoiceProduct: any) => new InvoiceProduct(invoiceProduct)
        )) ||
      [];
    this.invoiceServices =
      (data.invoiceServices &&
        data.invoiceServices.map(
          (invoiceService: any) => new InvoiceService(invoiceService)
        )) ||
      [];
    this.invoiceEquipments =
      (data.invoiceEquipments &&
        data.invoiceEquipments.map(
          (invoiceEquipment: any) => new InvoiceEquipment(invoiceEquipment)
        )) ||
      [];
    this.invoiceWorkers =
      (data.invoiceWorkers &&
        data.invoiceWorkers.map(
          (invoiceWorker: any) => new InvoiceWorker(invoiceWorker)
        )) ||
      [];
    this.invoiceTags =
      (data.invoiceTags &&
        data.invoiceTags.map(
          (invoiceTag: any) => new InvoiceTag(invoiceTag)
        )) ||
      [];
  }

  public toggleChecked() {
    this.checked = !this.checked;
  }
}

export class InvoiceSignatureViewModel {
  number: string;
  signature: string;
  isSigned: boolean;
  signedAt: Date;
  customerIdentifier: string;
  customerName: string;
  customerType: number;

  constructor(data: any = {}) {
    this.number = data.number;
    this.signature = data.signature;
    this.isSigned = !!data.signature;
    this.signedAt = data.signedAt && new Date(data.signedAt.date);
    this.customerIdentifier = data.customerIdentifier;
    this.customerName = data.customerName;
    this.customerType = data.customerType;
  }
}
